import React, {useMemo} from 'react';
import {useLocaleContext} from "./translations/LocaleContext";
import {Button, Image} from "antd";
import {useThrottledCallback} from "use-debounce";
import {useTranslation} from "react-i18next";

export const SwitchLanguageIcon: React.FC = () => {
    const { locale, options, swapLocales } = useLocaleContext();
    const flag = useMemo(() => {
        return options.find(opt => opt.value !== locale)?.url;
    }, [locale, options]);

    return (
        <Image src={flag} alt={'switch language'} preview={false}/>
    )
}

export const LanguageSwitchButton: React.FC = () => {
    const { swapLocales } = useLocaleContext();

    const {t} = useTranslation();
    const throttledSwap = useThrottledCallback(swapLocales, 1000);

    return (
        <Button type={"link"} icon={<SwitchLanguageIcon />} onClick={throttledSwap}></Button>
    )
}